export const VIEW = {
	CHATROOM: "CHATROOM",
	ACCESSIBILITY: "ACCESSIBILITY",
	LOGIN: "LOGIN",
	SETTINGS: "SETTINGS",
};
